module.exports = __webpack_public_path__ + "static/img/hour.9faf9a69.jpg";